/**
 * Qué ofrece la interfaz según los permisos de la sesión.
 *
 * Ocultar un elemento es COMODIDAD, no autorización: el servidor exige el
 * permiso en el endpoint y devuelve 403 sin él. Esto solo evita ofrecer una
 * acción que ya sabemos que va a fallar.
 *
 * En desarrollo local no hay sesión con permisos y se ofrece todo, igual que
 * hace `require()` en el backend cuando no hay proveedor de identidad.
 */

import type { SessionInfo } from "./types";

export function may(session: SessionInfo, permission: string): boolean {
  if (!session.permissions) return true;
  return session.permissions.includes(permission);
}

/** Solo el administrador configura el membrete de los documentos. */
export function mayManageSettings(session: SessionInfo): boolean {
  return may(session, "settings:manage");
}

/**
 * Si se ofrece la conciliación técnica del mapping.
 *
 * Es un permiso distinto de `financial_statements:read`: leer el estado oficial
 * y examinar la estructura `B*` con la que se construye no son la misma
 * autorización. Hoy lo tienen los tres roles, así que en la práctica no
 * restringe a nadie; lo que cambia es que el permiso de leer el documento deja
 * de conceder la vista técnica, y eso se cobra el día que exista un cuarto rol
 * de solo lectura.
 */
export function mayReconcileMapping(session: SessionInfo): boolean {
  return may(session, "mapping:reconcile");
}

/**
 * Si se ofrece el formulario para aprobar dónde va una cuenta nueva.
 *
 * Solo el contador tiene `mapping:write`; el administrador y el auditor ven la
 * pestaña pero no el formulario. El `POST` lo exige igual.
 */
export function mayApproveClassification(session: SessionInfo): boolean {
  return may(session, "mapping:write");
}
